import { FC } from 'react';
import {
  CalendarTodayOutlined,
  Email,
  FacebookRounded,
  FlagOutlined,
  ForumOutlined,
  HomeOutlined,
  Instagram,
  LaptopOutlined,
  LocationOn,
  Phone,
  Twitter,
  YouTube,
} from '@mui/icons-material';
import { Footer } from './footer';
import { ROUTES } from '../../routes';
import { LinkListProps } from '../../components/link-list/link-list';
import { IMidia } from '../../components/social-midia/social-midia';

export const FooterContainer: FC = () => {
  const social: IMidia[] = [
    { Icon: Instagram, link: 'https://instagram.com/governoes' },
    { Icon: FacebookRounded, link: 'https://facebook.com/governoes' },
    { Icon: YouTube, link: 'https://youtube.com/governoes' },
    { Icon: Twitter, link: 'https://twitter.com/governoes' },
  ];

  const lists: LinkListProps[] = [
    {
      title: 'Mapa do nosso Portal',
      Icon: LaptopOutlined,
      linkList: [
        { 
          text: 'Início', 
          Icon: HomeOutlined, 
          link: '/',
        },
        {
          text: 'Serviços Disponíveis',
          Icon: FlagOutlined,
          link: ROUTES.SERVICE_LIST_PAGE,
        },
        {
          text: 'Órgãos e Secretarias',
          Icon: ForumOutlined,
          link: '/secretarias-e-orgaos',
        },
        {
          text: 'Notícias',
          Icon: CalendarTodayOutlined,
          link: '/noticias',
        },
      ],
    },
  ];

  const contacts = [
    {
      Icon: Phone,
      text: '+55 (27) 3636-1024',
    },
    {
      Icon: LocationOn,
      text: 'Praça João Clímaco, 142 - Cidade Alta, Centro, Vitória/ES - CEP: 29015-110',
    },
    {
      Icon: Email,
      text: 'ouvidoria@es.gov.br',
    },
  ];

  return <Footer lists={lists} social={social} contacts={contacts} />;
};
